<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>裂变海报</div>
		<div style="margin-top: 20px;">
			<router-link to="/newPoster"><el-button type="primary" size="small">新建裂变活动</el-button></router-link>
		</div>
		<div class="title1" style="margin-top: 20px;">
			<div class="left">
				<el-radio-group size="small" v-model="tableState">
					<el-radio-button label="进行中"></el-radio-button>
					<el-radio-button label="已过期"></el-radio-button>
				</el-radio-group>
			</div>
			<div class="right">
				<el-select v-model="activeState" style="width: 150px;margin-right: 20px;" size="small">
					<el-option v-for="item in activeStateList" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
				<el-input type="text" placeholder="请输入优惠券名称" style="width: 200px;margin-right: 20px;"
					size="small"></el-input>
				<el-button type="primary" size="small">筛选</el-button>
			</div>
		</div>
		<div class="tabelContent" style="margin-top: 20px;">
			<el-table :header-cell-style="{background:'#F2F2F4','text-align':'center'}" :data="exchangeCodeList"
				style="width: 100%">
				<el-table-column prop="name1" align="center" label="裂变活动名称"></el-table-column>
				<el-table-column label="活动商品" prop="name2" align="center"></el-table-column>
				<el-table-column align="center" label="有效期">
					<template slot-scope="scope">
						<p>至{{scope.row.name3}}</p>
					</template>
				</el-table-column>
				<el-table-column label="已扫码用户" prop="name4" align="center"></el-table-column>
				<el-table-column label="操作" align="center" width="180">
					<template slot-scope="scope">
						<p>进行中</p>
						<p style="margin-top: 10px;"><el-button type="text" @click="dialog_touf=true">定向发送</el-button>
						</p>
						<p>
							<el-button type="text">编辑</el-button>
							<el-button type="text">下载</el-button>
							<el-button type="text" style="color: red;">删除</el-button>
						</p>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background style="margin-top: 30px;" layout="total, sizes, prev, pager, next, jumper"
				:page-size="10" :total="80">
			</el-pagination>
		</div>
		<!-- 推广 -->
		<el-dialog :visible.sync="dialog_tuig" width="25%">
			<div class="dia_title">优惠券H5</div>
			<div class="erwei">
				<img src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps1eb15cb7c10e81b9-5a84-438d-b0da-0865ed2f6393" />
			</div>
			<div>
				<div class="downerwei" @click="downloadCodeImg(img)">
					下载二维码
				</div>
			</div>
			<section class="form">
				<el-input :disabled="true" size="small" v-model="cjurl" style="width: 252px;margin-left:50px;margin-top: 20px;
			 margin-bottom:30px;"></el-input>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" v-clipboard:copy="cjurl" v-clipboard:success="onCopy"
						v-clipboard:error="onError" @click="dialog_tuig = copy">复
						制</el-button>
				</span>
			</section>
		</el-dialog>
		<!-- 定向投放 -->
		<el-dialog :visible.sync="dialog_touf" width="50%">
			<div class="title" style="margin-top:-43px;">
				<div class="blue"></div>
				<div style="flex: 1;">运营计划管理</div>
			</div>
			<el-form label-width="80px">
				<el-form-item label="选择用户">
					<el-radio v-model="chooseruser" value="1" label="全部用户"></el-radio>
					<el-radio v-model="chooseruser" value="2" label="指定用户群体"></el-radio>
				</el-form-item>
				<el-form-item label="选择用户">
					<div class="boton">
						<div class="boton1">
							<div class="boton1_title" @click="dialog_shangzhi=true">+添加商品用户</div>
							<div class="botonlist">
								高活跃用户
								<div @click="clear_bon">×</div>
							</div>
						</div>
						<div class="boton1">
							<div class="boton1_title" @click="dialog_user=true">+指定用户群</div>
							<div class="botonlist">
								高活跃用户
								<div @click="clear_bon">×</div>
							</div>
						</div>
						<div class="duo">
							可多选
						</div>
					</div>
				</el-form-item>
				<el-form-item label="推送时间">
					<div class="bon_data">
						<el-date-picker size="small" v-model="time1" type="datetime"
							placeholder="选择日期时间"></el-date-picker>
						<div>至</div>
						<el-date-picker size="small" v-model="time2" type="datetime"
							placeholder="选择日期时间"></el-date-picker>
					</div>
					<div class="lastbottom">
						<el-button size="small" @click="dialog_touf=false">取 消</el-button>
						<el-button type="primary" size="small">确 定</el-button>
					</div>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- 定向投放 -->
		<div class="lastdig">
			<el-dialog :visible.sync="dialog_user" width="50%">
				<div class="tanchutitle">添加用户群</div>
				<el-table :height="300" :data="tableData_1" style="width: 100%">
					<el-table-column prop="date" label="选择">
						<template slot-scope="scope">
							<el-checkbox :key="scope.row.id"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="群名称"></el-table-column>
				</el-table>
				<div class="lastbottom" style="margin-left: 38%;">
					<el-button size="small" @click="dialog_user=false">取 消</el-button>
					<el-button type="primary" size="small">确 定</el-button>
				</div>
			</el-dialog>
		</div>
		<!-- 添加商品用户/指定用户 -->
		<div class="lastdig">
			<el-dialog :visible.sync="dialog_shangzhi" width="40%">
				<div style="margin-top: -40px;">
					<el-tabs type="card">
						<el-tab-pane label="剪发服务">
							<el-checkbox-group v-model="checkList">
								<el-table :height="300" :data="tableData_1" style="width: 100%">
									<el-table-column prop="date" label="选择">
										<template slot-scope="scope">
											<el-checkbox :key="scope.row.id"></el-checkbox>
										</template>
									</el-table-column>
									<el-table-column prop="name" label="姓名"></el-table-column>
									<el-table-column prop="address" label="地址"></el-table-column>
								</el-table>
							</el-checkbox-group>
						</el-tab-pane>
						<el-tab-pane label="商城商品">
							<el-table :height="300" :data="tableData_1" style="width: 100%">
								<el-table-column prop="date" label="选择">
									<template slot-scope="scope">
										<el-checkbox :key="scope.row.id"></el-checkbox>
									</template>
								</el-table-column>
								<el-table-column prop="name" label="姓名"></el-table-column>
								<el-table-column prop="address" label="地址"></el-table-column>
							</el-table>
						</el-tab-pane>
						<el-tab-pane label="会员">
							<el-table :height="300" :data="tableData_1" style="width: 100%">
								<el-table-column prop="date" label="选择">
									<template slot-scope="scope">
										<el-checkbox :key="scope.row.id"></el-checkbox>
									</template>
								</el-table-column>
								<el-table-column prop="name" label="姓名"></el-table-column>
								<el-table-column prop="address" label="地址"></el-table-column>
							</el-table>
						</el-tab-pane>
					</el-tabs>
				</div>
				<div class="mybotton">
					<el-button size="small" @click="dialog_shangzhi=false">取消</el-button>
					<el-button type="primary" size="small">保存</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableState: "进行中",
				activeState: "全部活动",
				activeStateList: [],
				activeTime: "",
				exchangeCodeList: [{
					name1: "国庆5天券",
					name2: "会员",
					name3: "2020-08-17 20:00",
					name4: 83
				}],
				deleteAd: false,
				dialog_tuig: false,
				dialog_user: false,
				//选择状态
				totalstate: "",
				// 选择类型
				totaltype: "",
				// 优惠券名称
				youhuiname: "",
				// 推广页面
				dialog_tuig: false,
				cjurl: "https://lanhu.oss-cn-beijing.aliyuncs.com/ps1eb15cb7c10e81b9-5a84-438d-b0da-0865ed2f6393",
				img: 'https://lanhu.oss-cn-beijing.aliyuncs.com/ps1eb15cb7c10e81b9-5a84-438d-b0da-0865ed2f6393',
				// 定向投放
				dialog_touf: false,
				// chooseruser
				chooseruser: "",
				time1: "",
				time2: "",
				//添加商品用户
				dialog_shangzhi: false,
				storeval: [{
					label: "全部状态",
					value: 1,
				}, {
					label: "未开始",
					value: 2,
				}, {
					label: "进行中",
					value: 3,
				}, {
					label: "已开始",
					value: 4,
				}, {
					label: "已经失效",
					value: 5,
				}],
				// 选择状态
				stateVal: "",
				statelist: [{
					label: "全部类型",
					value: 1,
				}, {
					label: "满减卷",
					value: 2,
				}, {
					label: "折扣卷",
					value: 3,
				}, {
					label: "商品卷",
					value: 4,
				}, {
					label: "积分卷",
					value: 5,
				}, ],
				currentPage4: 4,
				tableData_1: [{
					id: 1,
					date: '2016-05-02',
					name: '王小虎1',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					id: 2,
					date: '2016-05-04',
					name: '王小虎2',
					address: '上海市普陀区金沙江路 1517 弄'
				}, {
					id: 3,
					date: '2016-05-01',
					name: '王小虎3',
					address: '上海市普陀区金沙江路 1519 弄'
				}, {
					id: 4,
					date: '2016-05-03',
					name: '王小虎4',
					address: '上海市普陀区金沙江路 1516 弄'
				}],
				tableData_2: [{
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-04',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1517 弄'
				}, {
					date: '2016-05-01',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1519 弄'
				}, {
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄'
				}],
				checkList: [],
			}
		},
		methods: {
			//复制路劲
			onCopy() {
				this.$message({
					message: `复制成功！`,
					type: 'success'
				});
				this.snackBar.info(this.$t('prompt.copySuccess'))
			},
			onError() {
				this.$message.error(this.$t('prompt.copyFail'))
			},
			clear_bon() {
				this.$confirm('是否要删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				});
			},
		}
	}
</script>

<style lang="less" scoped>
	p {
		padding: 0;
		margin: 0;
	}

	.title1 {
		width: 100%;

		.left {
			float: left;
		}

		.right {
			float: right;
		}

		&::after {
			content: "";
			width: 1px;
			display: block;
			clear: both;
		}
	}

	.tanchutitle {
		margin-top: -30px;
		width: 100%;
		height: 42px;
		line-height: 42px;
		background-color: #F2F2F2;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #888888;
		box-sizing: border-box;
		padding-left: 10px;

	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	// 弹出框内容
	.dia_title {
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #525252;
	}

	.erwei {
		width: 157px;
		height: 157px;
		margin: 20px auto;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.downerwei {
		cursor: pointer;
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #409EFF;
	}

	.dialog-footer {
		margin-top: -10px;
		margin-bottom: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	// 
	.boton {
		display: flex;

		>div {
			margin-right: 15px;
			flex-wrap: wrap;

			.boton1_title {
				cursor: pointer;
				height: 32px;
				padding-left: 8px;
				padding-right: 8px;
				border: 1px dashed #D9DCE3;
				border-radius: 4px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #959595;
				line-height: 32px;
				text-align: center;
			}

			.botonlist {
				margin-top: 15px;
				text-align: center;
				line-height: 32px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #959595;
				width: 99px;
				height: 32px;
				border: 1px solid #D9DCE3;
				border-radius: 4px;
				position: relative;

				div {
					cursor: pointer;
					line-height: 15px;
					position: absolute;
					width: 16px;
					height: 16px;
					background-color: black;
					color: white;
					border-radius: 50%;
					font-size: 14px;
					right: -8px;
					top: -8px;
				}
			}
		}

	}

	.bon_data {
		display: flex;

		div {
			padding-left: 5px;
			padding-right: 5px;
		}
	}

	.lastbottom {
		width: 138px;
		margin-left: 29%;
		margin-top: 25px;
	}

	.duo {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #959595;
		opacity: 0.51;
		margin-top: -4px;
	}

	.lastdig {
		/deep/.el-dialog__close {
			display: none;
		}

		.mybotton {
			margin-left: 39%;
			margin-top: 15px;
		}
	}
</style>